import Footer from "../../components/common/Footer/Footer";
import Header from "../../components/common/Header/Header";
import ContactUsForm from "../../components/common/ContactUs/ContactUsForm";
import classes from "../../styles/Home.module.scss";
import classnames from "classnames";
import { nanoid } from "nanoid";
import Banner from "../../components/common/Banner/Banner";
import BannerType from "../../global/banner-type";
import useIsMobile from "../../components/hooks/useIsMobile";
import { useNavigate } from "react-router";
import { APP_PATH } from "../../routes/route";
import { ourChannels, brands, platforms } from "../../global/constant";
import OurProducts from "../Home/components/OurProducts";
import OurClientBase from "../Home/components/OurClientBase";
import Introduction from "./components/Introduction";
import cloudImg from "../../assets/images/cloud.png";
import CustomImage from "../../components/core/CustomImage/CustomImage";
import mykare_logo_white from "../../assets/icons/mykare_logo_white.svg";
import CustomIcon from "../../components/core/CustomIcon/CustomIcon";

const LandingPage = () => {
  const isMobile = useIsMobile({ breakpoint: 768 });
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={classnames(classes.container, "minheightCont100vh")}>
        <div className={classes.lp_contactus}>
          <div className={classes.lp_contactusintro}>
            <CustomImage src={mykare_logo_white} height={68} width={126} />
            <div className={classes.revolutionizing}>Revolutionizing</div>
            <div className={classes.lp_intro_subheading}>
              the way you work,<br></br>collaborate &<br></br>innovate
            </div>
            <CustomImage
              src={cloudImg}
              alt={"Revolutionizing"}
              width={"100%"}
            />
          </div>
          <div className={classes.lp_contactusform}>
            <div className={classes.lp_contactusformchild}>
              <div className={classes.lp_contactusheading}>Contact us now!</div>
              <div className={classes.lp_contactussubheading}>
                Tell us about yourself and we will be in touch shortly.
              </div>
              <ContactUsForm />
            </div>
          </div>
        </div>
        <OurClientBase
          brands={brands}
          showItems={10}
          className={classes.lp_brands}
        />
        <div className={classnames("containerWidth")}>
          <div>
            <div
              className={classnames(classes.heading, "heading")}
              style={{ fontSize: "32px" }}
            >
              Our Channels
            </div>
            <div className={classnames("subheading")}>
              Be omnipresent in your customer’s mind with our channel coverage
            </div>
            <div
              className={classnames(classes.flex_box)}
              style={{ marginTop: 20 }}
            >
              {ourChannels.map(channel => {
                if (channel.id === "contactus") {
                  return null;
                }
                return (
                  <Banner
                    type={BannerType.CHANNEL_BANNER}
                    {...channel}
                    key={nanoid()}
                    className={classes.alignCenter}
                    clickHandler={() =>
                      navigate(`${APP_PATH}/channels/${channel.id}`)
                    }
                  />
                );
              })}
            </div>
          </div>
          <OurProducts platforms={platforms} className={classes.lp_platform} />
        </div>
        <Introduction />
        <Footer />
      </div>
    </>
  );
};
export default LandingPage;
